import { css } from "styled-components";
import { BladeContent } from "../../../../components/BladeContent";
import { Media } from "../../../../components/Media";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    background-color: ${paletteTokens.bladebg1};
    padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};
  }

  /* has sideMedia */
  ${BladeContent}:not(.position-undefined) {
    display: flex;
    gap: ${chroma.spacers.constant.m};

    &.position-after {
      flex-direction: row-reverse;
    }

    &.position-before {
      flex-direction: row;
    }

    ${chroma.mediaQueries.tabletDown} {
      &.position-after,
      &.position-before {
        flex-direction: column;
      }
    }

    /* SideMedia and RichText containers */
    & > div {
      flex: 1 1 50%;

      & > ${Media} {
        /*
         * ensures that unactionable media does not change height along with rich text column, 
         * also places controls of audio on the top of media column
         * NOTE: This will revert default browser behavior of media elements to work mostly as with 'auto',
         * but for some reason Chrome sets height of audio element to 0 when using 'auto' value.
         */
        height: revert;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map